import { connect } from 'react-redux';
import NotificationView from './view.jsx';
import { fetchUserNotifications, invalidateNotificationUpdate, updateUserNotification } from 'src/redux/actions/users.ts';

const mapStateToProps = (state, ownProps) => {
  var notificationsPreferences = state.users.notifications;

  return {
    preferences: notificationsPreferences.item || {},
    loading: notificationsPreferences.loading,
    updating: notificationsPreferences.updating,
    updated: notificationsPreferences.updated,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserNotification: () => {
      return dispatch(fetchUserNotifications())
    },

    updateUserNotification: (eventData) => {
      return dispatch(updateUserNotification(eventData))
    },
    invalidateNotificationUpdate: () => {
      return dispatch(invalidateNotificationUpdate());
    }
  }
}

const NotificationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(NotificationView);

export default NotificationPage;